import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectUserRoles = createSelector(
  (state: RootState) => state.user.roles,
  (roles: string[]) => roles
)

export default selectUserRoles
